import { VectorEditorAcrylicFigureFreeMobileCuttingLineAutoMuiS } from '../../S/Mui/module/VectorEditorAcrylicFigureFreeMobileCuttingLineAutoMuiS.js';
import { CommonNS, EditorNS } from '@marpple/sticker-editor';
import { $find, $findAll, $on } from 'fxdom/es';
import { VectorEditorFontF } from '../../../../../../Font/F/Function/module/VectorEditorFontF.js';
import {
  getOutlinePathsFromImgWithAdaptiveSimplify,
  makePathsBridged,
  pathOffsets,
} from '@marpple/stickerizer';
import svgpath from 'svgpath';
import { VectorEditorAcrylicFigureFreeMobileCuttingLineAutoF } from '../Function/module/VectorEditorAcrylicFigureFreeMobileCuttingLineAutoF.js';
import { each, go, tap } from 'fxjs/es';
import { VectorEditorAcrylicFigureFreeConstantS } from '../../../../S/Constant/module/VectorEditorAcrylicFigureFreeConstantS.js';
/*
 * 프론트에서 사용될 tab 옵션입니다.
 * https://www.notion.so/marpple/Marpple-UI-80875a30a63e436382a02e2d820f4695#2fecac9aa5f8457c92fa359c5ac71ef8
 * */
export const tab = {
  ...VectorEditorAcrylicFigureFreeMobileCuttingLineAutoMuiS.tab,

  inner_scroll_target: '', // modal 일때 이너 스크롤 엘리먼트 셀렉터

  makeData(tab) {}, // template 함수 인자에 들어갈 값을 리턴하는 함수,

  appending(tab_el) {
    tab_el.__mp_acrylic_figure_cutting_line_editor = null;
    tab_el.__mp_factor = 1;
    tab_el.__mp_art_board_width = tab_el.__mp_art_board_width ?? 0;
    tab_el.__mp_art_board_height = tab_el.__mp_art_board_height ?? 0;
    tab_el.__mp_ucs_x = tab_el.__mp_ucs_x ?? 0;
    tab_el.__mp_ucs_y = tab_el.__mp_ucs_y ?? 0;
    tab_el.__mp_ucs_width = tab_el.__mp_ucs_width ?? 0;
    tab_el.__mp_ucs_height = tab_el.__mp_ucs_height ?? 0;
    tab_el.__mp_stand_leg_ground_size_delta = tab_el.__mp_stand_leg_ground_size_delta ?? 4;
    tab_el.__mp_stand_leg_ground_position_delta = tab_el.__mp_stand_leg_ground_position_delta ?? 1;
    tab_el.__mp_stand_leg_ground_min_width = tab_el.__mp_stand_leg_ground_min_width ?? 0;
    tab_el.__mp_stand_leg_ground_max_width = tab_el.__mp_stand_leg_ground_max_width ?? 0;
    tab_el.__mp_stand_leg_ground_width = tab_el.__mp_stand_leg_ground_width ?? 0;
    tab_el.__mp_stand_leg_ground_height = tab_el.__mp_stand_leg_ground_height ?? 0;
    tab_el.__mp_stand_leg_notch_round = tab_el.__mp_stand_leg_notch_round ?? 1;
    tab_el.__mp_stand_leg_notch_width = tab_el.__mp_stand_leg_notch_width ?? 0;
    tab_el.__mp_stand_leg_notch_height = tab_el.__mp_stand_leg_notch_height ?? 0;
    tab_el.__mp_makeTargetImageEl = tab_el.__mp_makeTargetImageEl ?? null;
    tab_el.__mp_postProcess = tab_el.__mp_postProcess ?? null;
    tab_el.__mp_cutting_lines = [];
    tab_el.__mp_max_cutting_line_index = 5;
    tab_el.__mp_cur_cutting_line_index = 0;

    go(
      tab_el,

      tap(
        $findAll(`.header .prev`),
        each($on('click', VectorEditorAcrylicFigureFreeMobileCuttingLineAutoF.handleHeaderPrevButtonClick())),
      ),
      tap(
        $findAll(`.header .next`),
        each(
          $on(
            'click',
            VectorEditorAcrylicFigureFreeMobileCuttingLineAutoF.handleHeaderNextButtonClick({ tab_el }),
          ),
        ),
      ),

      tap(
        $findAll(`.footer .controls .control.control_auto .control_auto_button.control_auto_button_minus`),
        each(
          $on(
            'click',
            VectorEditorAcrylicFigureFreeMobileCuttingLineAutoF.handleControlAutoMinusButtonClick({ tab_el }),
          ),
        ),
      ),
      tap(
        $findAll(`.footer .controls .control.control_auto .control_auto_button.control_auto_button_plus`),
        each(
          $on(
            'click',
            VectorEditorAcrylicFigureFreeMobileCuttingLineAutoF.handleControlAutoPlusButtonClick({ tab_el }),
          ),
        ),
      ),
      tap(
        $findAll(`.footer .controls .control.control_manual .control_manual_button`),
        each(
          $on(
            'click',
            VectorEditorAcrylicFigureFreeMobileCuttingLineAutoF.handleControlManualButtonClick({ tab_el }),
          ),
        ),
      ),
    );
  }, // tab 엘리먼트가 만들어지면 울리는 함수
  appended(tab_el) {
    const acrylic_figure_cutting_line_editor =
      new EditorNS.AcrylicCuttingLineEditorNS.MobileNS.AcrylicCuttingLineMobileEditor({
        window,
        document,
        touch_margin: 6,
        min_zoom_scale: 1,
        max_zoom_scale: 3,
      });
    tab_el.__mp_acrylic_figure_cutting_line_editor = acrylic_figure_cutting_line_editor;
    acrylic_figure_cutting_line_editor.initDOM();
    acrylic_figure_cutting_line_editor.initEditor();

    const editor_container_el = $find('.editor_container')(tab_el);
    if (editor_container_el == null) {
      const error = new Error(`editor_container 클래스를 가진 엘리먼트를 찾을 수 없습니다.`);
      error.__mp_alert_message = T(
        'modules::VectorEditor::AcrylicFigure::Free::Mobile::CuttingLineAuto::template::error_message::no_editor_container_el',
      );
      throw error;
    }
    acrylic_figure_cutting_line_editor.appendTo(editor_container_el);
  }, // tab 엘리먼트가 html에 붙으면 울리는 함수
  showing(tab_el) {}, // tab 엘리먼트 show하기 전 울리는 함수
  showed(tab_el) {}, // tab 엘리먼트 show하고 나서 울리는 함수
  async rendered(tab_el) {
    if (tab_el.__mp_acrylic_figure_cutting_line_editor == null) {
      const error = new Error(`tab_el.__mp_acrylic_figure_cutting_line_editor 객체가 null 입니다.`);
      error.__mp_alert_message = T(
        'modules::VectorEditor::AcrylicFigure::Free::Mobile::CuttingLineAuto::template::error_message::no_acrylic_figure_cutting_line_editor',
      );
      throw error;
    }
    const editor = tab_el.__mp_acrylic_figure_cutting_line_editor;

    if (tab_el.__mp_makeTargetImageEl == null) {
      const error = new Error(`tab_el.__mp_makeTargetImageEl 함수가 null 입니다.`);
      error.__mp_alert_message = T(
        'modules::VectorEditor::AcrylicFigure::Free::Mobile::CuttingLineAuto::template::error_message::no_make_target_image_el',
      );
      throw error;
    }
    const makeTargetImageEl = tab_el.__mp_makeTargetImageEl;

    $.don_loader_start();
    try {
      editor.fitSize();

      const target_image_el = await makeTargetImageEl({ factor: 1 });
      editor.setTargetImageEl(target_image_el);
      const min_px = 1024;
      const factor_x = min_px / target_image_el.width.baseVal.value;
      const factor_y = min_px / target_image_el.height.baseVal.value;
      tab_el.__mp_factor = Math.max(factor_x, factor_y);
      const large_target_image_el = await makeTargetImageEl({ factor: tab_el.__mp_factor });
      const font_style_el = await VectorEditorFontF.makeFontStyleEl({ is_encode_base64: true })(
        large_target_image_el,
      );
      const font_style_defs_el = document.createElementNS(CommonNS.ConstNS.SVG_NAMESPACE, 'defs');
      font_style_defs_el.appendChild(font_style_el);
      large_target_image_el.prepend(font_style_defs_el);
      const large_target_image_svg_data_url = /** @type {string} */ await new Promise((resolve, reject) => {
        try {
          const svg_str = new XMLSerializer().serializeToString(large_target_image_el);
          const svg_blob = new Blob([svg_str], { type: 'image/svg+xml' });
          const file_reader = new FileReader();
          file_reader.onerror = (event) => {
            console.error(event);
            const error = new Error('large_target_image_el 을 data_url 로 변환하는 데 실패했습니다.');
            error.__mp_alert_message = T(
              'modules::VectorEditor::AcrylicFigure::Free::Mobile::CuttingLineAuto::template::error_message::svg_data_url_making_error',
            );
            reject(error);
          };
          file_reader.onload = () => resolve(file_reader.result);
          file_reader.readAsDataURL(svg_blob);
        } catch (error) {
          reject(error);
        }
      });
      const large_target_image_img_el = /** @type {HTMLImageElement} */ await new Promise(
        (resolve, reject) => {
          const img_el = new Image();

          function onLoad() {
            img_el.removeEventListener('load', onLoad);
            img_el.removeEventListener('error', onError);
            resolve(img_el);
          }
          function onError(event) {
            img_el.removeEventListener('load', onLoad);
            img_el.removeEventListener('error', onError);

            console.error(event);
            const error = new Error('large_target_image_svg_data_url 을 img_el 에 로드하는 데 실패했습니다.');
            error.__mp_alert_message = T(
              'modules::VectorEditor::AcrylicFigure::Free::Mobile::CuttingLineAuto::template::error_message::svg_img_el_load_error',
            );
            reject(error);
          }
          img_el.addEventListener('load', onLoad);
          img_el.addEventListener('error', onError);

          img_el.src = large_target_image_svg_data_url;
        },
      );
      await new Promise((resolve) => setTimeout(resolve, 600));
      const large_target_image_canvas_el = document.createElement('canvas');
      large_target_image_canvas_el.width = large_target_image_img_el.width;
      large_target_image_canvas_el.height = large_target_image_img_el.height;
      const large_target_image_canvas_ctx = large_target_image_canvas_el.getContext('2d');
      large_target_image_canvas_ctx.drawImage(
        large_target_image_img_el,
        0,
        0,
        large_target_image_img_el.width,
        large_target_image_img_el.height,
        0,
        0,
        large_target_image_canvas_el.width,
        large_target_image_canvas_el.height,
      );
      const large_target_image_png_blob = /** @type {Blob} */ await new Promise((resolve, reject) => {
        try {
          large_target_image_canvas_el.toBlob((blob) => {
            if (blob == null) {
              const error = new Error(
                'large_target_image_canvas_el 에서 Blob 객체를 만드는 데 실패했습니다.',
              );
              error.__mp_alert_message = T(
                'modules::VectorEditor::AcrylicFigure::Free::Mobile::CuttingLineAuto::error_message::svg_canvas_to_blob_error',
              );
              reject(error);
            } else {
              resolve(blob);
            }
          }, 'image/png');
        } catch (error) {
          reject(error);
        }
      });
      const large_target_image_png_data_url = /** @type {string} */ await new Promise((resolve, reject) => {
        try {
          const file_reader = new FileReader();
          file_reader.onerror = (event) => {
            console.error(event);
            const error = new Error(`large_target_image_png_blob 을 data_url 로 변환하는 데 실패했습니다.`);
            error.__mp_alert_message = T(
              'modules::VectorEditor::AcrylicFigure::Free::Mobile::CuttingLineAuto::error_message::png_data_url_making_error',
            );
            reject(error);
          };
          file_reader.onload = () => resolve(file_reader.result);
          file_reader.readAsDataURL(large_target_image_png_blob);
        } catch (error) {
          reject(error);
        }
      });
      const fitted_cutting_line = await getOutlinePathsFromImgWithAdaptiveSimplify(
        large_target_image_png_data_url,
      );
      const fitted_bridged_cutting_line = await makePathsBridged(fitted_cutting_line.paper_obj);
      const base_outer_cutting_line = await pathOffsets(
        fitted_bridged_cutting_line.paper_obj,
        2 * tab_el.__mp_factor,
      );
      const base_outer_cutting_line_path_data = svgpath(base_outer_cutting_line.path_data)
        .scale(1 / tab_el.__mp_factor)
        .toString();
      const base_inner_cutting_line = await pathOffsets(
        base_outer_cutting_line.paper_obj,
        -VectorEditorAcrylicFigureFreeConstantS.SAFE_MARGIN_MM * tab_el.__mp_factor,
      );
      const base_inner_cutting_line_path_data = svgpath(base_inner_cutting_line.path_data)
        .scale(1 / tab_el.__mp_factor)
        .toString();
      tab_el.__mp_cutting_lines = [
        {
          offset: 0,
          inner_cutting_line: base_inner_cutting_line,
          inner_cutting_line_path_data: base_inner_cutting_line_path_data,
          outer_cutting_line: base_outer_cutting_line,
          outer_cutting_line_path_data: base_outer_cutting_line_path_data,
        },
      ];
      await VectorEditorAcrylicFigureFreeMobileCuttingLineAutoF.setCuttingLine({ tab_el, index: 0 });

      const outer_cutting_line_path_el = editor.getOuterCuttingLinePathEl();
      const outer_cutting_line_path_el_bbox = outer_cutting_line_path_el.getBBox();
      tab_el.__mp_ucs_x = outer_cutting_line_path_el_bbox.x;
      tab_el.__mp_ucs_y = outer_cutting_line_path_el_bbox.y;
      tab_el.__mp_ucs_width = outer_cutting_line_path_el_bbox.width;
      tab_el.__mp_ucs_height = outer_cutting_line_path_el_bbox.height;
      const view_box_vo = editor.calculateViewBoxFitTo({
        size_in_ucs: {
          x: tab_el.__mp_ucs_x - 5,
          y: tab_el.__mp_ucs_y - 5,
          width: tab_el.__mp_ucs_width + 10,
          height: tab_el.__mp_ucs_height + 10,
        },
        padding_in_vcs: { top: 16 + 48, right: 16, bottom: 16 + 144, left: 16 },
        vertical_align: 'center',
      });
      editor.setViewBox(view_box_vo);

      VectorEditorAcrylicFigureFreeMobileCuttingLineAutoF.setSizeGuide({
        tab_el,
        editor: tab_el.__mp_acrylic_figure_cutting_line_editor,
      });
    } finally {
      $.don_loader_end();
    }
  }, // tab 에 관련된 모든 메소드와 엘리먼트 작업이 끝날때 울리는 함수

  hiding(tab_el, v) {}, // tab이 가려지기 전 울리는 함수
  hided(tab_el, v) {}, // tab이 가려진 후 울리는 함수
  removing(tab_el, v) {}, // tab이 삭제되기 전 울리는 함수
  removed(tab_el, _v) {
    if (tab_el.__mp_acrylic_figure_cutting_line_editor) {
      const editor = tab_el.__mp_acrylic_figure_cutting_line_editor;
      editor.destroy();
    }

    tab_el.__mp_acrylic_figure_cutting_line_editor = null;
    tab_el.__mp_factor = 1;
    tab_el.__mp_art_board_width = 0;
    tab_el.__mp_art_board_height = 0;
    tab_el.__mp_ucs_x = 0;
    tab_el.__mp_ucs_y = 0;
    tab_el.__mp_ucs_width = 0;
    tab_el.__mp_ucs_height = 0;
    tab_el.__mp_stand_leg_ground_size_delta = 0;
    tab_el.__mp_stand_leg_ground_position_delta = 0;
    tab_el.__mp_stand_leg_ground_min_width = 0;
    tab_el.__mp_stand_leg_ground_max_width = 0;
    tab_el.__mp_stand_leg_ground_width = 0;
    tab_el.__mp_stand_leg_ground_height = 0;
    tab_el.__mp_stand_leg_notch_round = 1;
    tab_el.__mp_stand_leg_notch_width = 0;
    tab_el.__mp_stand_leg_notch_height = 0;
    tab_el.__mp_makeTargetImageEl = null;
    tab_el.__mp_postProcess = null;
    tab_el.__mp_cutting_lines = [];
    tab_el.__mp_max_cutting_line_index = 1;
    tab_el.__mp_cur_cutting_line_index = 0;
  }, // tab이 삭제된 후 울리는 함수

  infinite(tab_el) {}, // tab 엘리먼트에 무한스크롤을 사용할때 쓰는 함수, 사용시 반드시 return MuiF.tabInfinite(...)
};
